import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import AddPurchaseOrderLayer from '../components/AddPurchaseOrderLayer'

export const AddPurchaseOrderPage = () => {
  return (
    <MasterLayout>
        <AddPurchaseOrderLayer  />
    </MasterLayout>
  )
}
